import moment from "moment-timezone";

export const getFormattedDate = (country: string, date: string) => {
    if (!Boolean(date)) {
        return "";
    }
    if (new Date(date).toString() !== "Invalid Date") {
        return country === "US"
            ? moment(date).format("MMM D YYYY")
            : country === "CA" || country === "TW"
            ? moment(date).format("YYYY MMM D")
            : moment(date).format("D MMM YYYY");
    } else {
        return date;
    }
};
